import styled from "styled-components";
import { ImgAurobilcarsLight, ImgBlankProfile } from "../../assets/images";
import useScreenSize from "../../hooks/useScreenSize";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getAllProfileDropdown } from "../../utils/navbar.utils";
import { useAuthFromRedux, useUserLogoutMutation } from "../../utils/user.utils";
import { removeAuth } from "../../redux/slice/authSlice";
import { removeToken } from "../../utils/token.utils";
import { BarIcon, CrossIcon, LogoutIcon } from "../../utils/icon.utils";
import { arrayMap } from "../../utils/array.utils";

export default function TopBar({ collapseToggle, collapse }) {
  const { user } = useAuthFromRedux();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isLg } = useScreenSize();
  const { loading, userLogout } = useUserLogoutMutation(["userLogout"]);

  const CollapseIcon = collapse && isLg ? CrossIcon : BarIcon;

  const profileDropdowns = getAllProfileDropdown();

  const handleLogout = async () => {
    const afterLogout = await userLogout();
    if (afterLogout?.status === 200) {
      dispatch(removeAuth());
      removeToken();
      navigate("/login");
    }
  };

  const handleNavigate = (link) => {
    navigate(link === "/profile" ? `/user/${user?.username}${link}` : link);
  };

  return (
    <div className="py-3 d-flex justify-content-between align-items-center">
      <HamburgerIcon
        className="d-flex align-items-center align-self-center"
        onClick={collapseToggle}>
        <Logo
          className="flex-shrink-0"
          style={{ backgroundImage: `url(${ImgAurobilcarsLight})` }}
        />
        <IconContainer className="ms-2 ms-lg-0">
          <CollapseIcon className="icon" />
        </IconContainer>
      </HamburgerIcon>

      <Dropdown className="dropdown">
        <div
          className="d-flex align-items-center dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          <Avatar
            className="rounded-circle"
            style={{ backgroundImage: `url(${ImgBlankProfile})` }}
          />
          <User className="ms-2">
            <Name className="m-0">{user?.name ?? "-"}</Name>
            <Role className="m-0">{user?.role?.name ?? ""}</Role>
          </User>
        </div>

        {loading ? "Processing..." : ""}

        <ul className="dropdown-menu mt-2 border-0 p-0">
          {arrayMap(profileDropdowns, (item, index) => {
            const Icon = item.icon;
            return (
              <li
                key={index + 1}
                onClick={() => handleNavigate(item.link)}
                className="dropdown-item py-2 d-flex align-items-center">
                <Icon />
                <span className="ms-2">{item.name}</span>
              </li>
            );
          })}
          <li>
            <button
              onClick={handleLogout}
              type="button"
              className="dropdown-item py-2 d-flex align-items-center">
              <LogoutIcon />
              <span className="ms-2">Log Out</span>
            </button>
          </li>
        </ul>
      </Dropdown>
    </div>
  );
}

const Avatar = styled.div`
  background-repeat: no-repeat;
  background-size: contain;
  height: 2.2rem;
  width: 2.2rem;
`;

const User = styled.div`
  display: none;

  @media (min-width: 992px) {
    display: block;
  }
`;

const Name = styled.h6`
  color: var(--main-title-color);
  font-weight: 600;
  font-size: 0.9rem;
`;

const Role = styled.p`
  color: var(--main-title-color);
  font-weight: 400;
  opacity: 0.7;
  font-size: 0.8rem;
`;

const HamburgerIcon = styled.div`
  cursor: pointer;
`;

const Logo = styled.div`
  height: 2.5rem;
  width: 2.5rem;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center center;

  @media (min-width: 992px) {
    display: none;
  }
`;

const IconContainer = styled.div`
  .icon {
    font-size: 1.5rem;
  }
`;

const Dropdown = styled.div`
  .dropdown-toggle::after {
    display: none;
  }
  cursor: pointer;

  .dropdown-item {
    font-weight: 500;
    color: var(--primary-color);
  }
  .dropdown-item:hover {
    color: var(--primary-text-color);
    background-color: var(--primary-hover-bg);
  }
`;
